export enum CourseParticipantsActions {
  Reset = "reset",
  FetchStudents = "fetchStudents",
  FetchPerson = "fetchPerson",
  PostStudent = "postStudent",
}
